import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';
import { map } from 'rxjs/operators';
import { LoginService } from '@uiowa/uiowa-header';

@Injectable({
  providedIn: 'root'
})
export class HomeGuard implements CanActivate {
  constructor(
    private router: Router,
    private readonly userService: UserService,
    private readonly loginService: LoginService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    this.loginService.returnUri = state.url;
    return this.userService.user$.pipe(
      map(u => {
        if (!u.isAuthenticated()) {
          this.loginService.login();
          return false;
        }
        if (u.isAdmin()) {
          this.router.navigateByUrl('/admin');
          return false;
        } else
        if (u.isEmployee()) {
          this.router.navigateByUrl('/employee');
          return false;
        }
      })
    );
  }
}
